export enum ConversationSubTabs {
  Opened = 'openedConversations',
  Waiting = 'waitingRoomConversations',
  Invited = 'invitedConversations',
}
